import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    financeData: any;

    constructor(private msalService: MsalService) {}

    async ngOnInit(): Promise<void> {
        await this.msalService.instance.initialize();
        console.log('MSAL initialized');
    }
}
